import { useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ApplicationState } from 'store/redux';
import * as AuthenticationStore from 'store/redux/Authentication';
import * as AlertStore from 'store/redux/Alerts';
import { IAuthenticationActionCreators } from 'store/redux/Authentication';
import { IAlertActionCreators } from 'store/redux/Alerts';
import Context from 'configuration/context';
import customLoginService from 'services/customLoginService';
import EntraOidcClient from 'clients/EntraOidcClient';
import MSLogin from '../components/controls/MSLogin/MSLogin';
import { CustomLogin } from 'components';
import './Login.css';
import { Alert } from 'reactstrap';

const Login = function ({ setLoginState, authenticationState }: ILoginProps) {
  const { t } = useTranslation('translation');
  const [showMsLogin, setShowMsLogin] = useState(() => {
    const state = new URLSearchParams(window.location.search).get('state');
    return !!state && EntraOidcClient.hasState(state);
  });
  const loginService = customLoginService.Create(
    Context.APIUrl + '/v1',
    { setLoginState },
    authenticationState
  );

  return (
    <div className="login-container center">
      <div className="col-md-6 offset-md-3">
        <h2>{t('login.LOGIN')}</h2>
        <Alert color="info">{t('login.EMERGENCY_INFO')}</Alert>
        {!showMsLogin && (
          <>
            <CustomLogin
              loginService={loginService}
              onOldLogin={() => {
                setShowMsLogin(true);
              }}
            />
          </>
        )}
        {showMsLogin && (
          <MSLogin authenticationState={authenticationState} setLoginState={setLoginState} />
        )}
      </div>
    </div>
  );
};

export type ILoginProps = IAuthenticationActionCreators &
  IAlertActionCreators & {
    authenticationState?: AuthenticationStore.UserState;
  };
export interface ICustomerResponsible {
  displayName: string;
  email: string;
  phone: string;
  imageUrl: string;
}

export type HealthCenterCategory = 'Nationella' | 'Assist' | 'Other';

export interface IResponsibleHealthCenter {
  id: number;
  name: string;
  email: string;
  category: HealthCenterCategory | string;
}

export interface ISiteReference {
  customerName: string;
  customerId: string;
  customerContacts?: ICustomerResponsible[];
  invoicesAreAvailable: boolean;
  orderServiceIsAvailable: boolean;
  movieServiceIsAvailable: boolean;
  reportServiceIsAvailable: boolean;
  defaultHealthCenter?: number;
  responsibleHealthCenter?: IResponsibleHealthCenter;
}

export interface IUserInRole {
  availableCustomers?: ISiteReference[];
  email?: string;
  name: string;
  role: string;
  selectedCustomer?: ISiteReference;
}

export default connect(
  (appState: ApplicationState) => ({ authenticationState: appState.authentication }),
  {
    ...AuthenticationStore.actions,
    ...AlertStore.actionCreators,
  }
)(Login);
